import { Injectable } from '@angular/core';

import { ApiService, AppContext, LogService } from './../shared';

@Injectable()
export class ShareResultsService {
  showEmail: boolean = false;
  message: string = '';
  show: boolean = false;
  searchId: string = '';
  emails: string = '';
  emailSubject: string = '';
  emailBody: string = '';

  success: boolean = false;
  loaderOn = false;

  constructor(private api: ApiService, private app: AppContext, private logger: LogService) {
    if (!this.app.isLoggedIn) {
      this.display('others');
    }
  }

  display(who: string) {
    if (who === 'others') {
      this.showEmail = true;
    } else {
      this.showEmail = false;
    }
  }

  share() {
    this.logger.log('share-results', 'share', this.emails);
    this.message = '';

    if (this.showEmail && this.emails.trim().length === 0) {
      this.message = 'Please specify an email';
      return;
    }
    if (this.emailBody.length > 1024) {
      this.message = 'Messages must be less than 1024 characters';
      return;
    }

    let params = {
      fromAddress: this.app.email,
      toAddress: this.app.email,
      subject: this.emailSubject,
      message: this.emailBody
    };
    if (this.showEmail) {
      params.toAddress = this.emails;
    }

    return this.api.getApiClient().then(client => this.callShare(client, params));
  }

  callShare(apigClient: any, query) {
    return new Promise((resolve, reject) => {
      this.loaderOn = true;
      this.success = false;
      this.logger.log('share.service', 'callShare', query);
      let params = {
        searchId: this.searchId
      };
      let body = query;
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {}
      };
      try {
        apigClient.searchesSearchIdSharePost(params, body, additionalParams)
          .then((result) => {
            this.logger.log('share.service', 'resolve', result);
            this.success = true;
            this.loaderOn = false;
            resolve();
          }).catch((err) => {
            this.api.handleError(err);
            this.loaderOn = false;
            reject();
          });
      } catch (ex) {
        this.logger.log('share.service', 'catch', ex);
        this.loaderOn = false;
        reject();
      }
    });
  }

  updateEmails(emails: Array<string>) {
    this.message = '';
    this.emails = emails.join(',');
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/share-results/share-results.service.ts